// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".IHuBjAEqpSRMXHTaaUxY{overflow-x:hidden;overflow-y:scroll}.p9DYe2kPD9yYZdlYHJ_0{margin:4px}", "",{"version":3,"sources":["webpack://./src/p5lab/AnimationTab/scrollable-list.module.scss"],"names":[],"mappings":"AAAA,sBACE,iBAAA,CACA,iBAAA,CAGF,sBACE,UAAA","sourcesContent":[".root {\n  overflow-x: hidden;\n  overflow-y: scroll;\n}\n\n.margins {\n  margin: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "IHuBjAEqpSRMXHTaaUxY",
	"margins": "p9DYe2kPD9yYZdlYHJ_0"
};
export default ___CSS_LOADER_EXPORT___;
